import { useQuery } from "@tanstack/react-query";
import type { TouchRecord } from "@shared/lastTouch";

export interface CoiListRow {
  id: string; name: string; title: string | null; email: string | null; phone: string | null;
  firmId: string | null; firmName: string | null; isCoi: boolean; specialty: string; geographicCoverage: string | null; howWeMet: string | null;
  ownerUserId: string | null; ownerName: string | null;
  lastTouch: TouchRecord | null; daysSinceTouch: number | null;
  introsOpen: number; introsSigned: number; sentCount: number; sectors: string[]; createdAt: string;
}
export interface ReferralRow {
  companyId: string; companyName: string; category: string; stage: string | null; status: string | null;
  introducedOn: string | null; note: string | null; ownerName: string | null; outcome: string; feeOpportunity: number | null;
  personId: string; personName: string;
}
/** Every COI person (derived columns included), or the same rolled up by firm. Key prefix "cois" is what other hooks invalidate. */
export function useCoiPeople() {
  return useQuery<CoiListRow[]>({
    queryKey: ["cois", "people"],
    queryFn: async () => { const r = await fetch("/api/cois?view=people", { credentials: "include" }); return r.ok ? r.json() : []; },
  });
}
